export default "__VITE_ASSET__cdb9551b__"